import * as signalR from '@microsoft/signalr';

let connection: signalR.HubConnection | null = null;
let startingPromise: Promise<signalR.HubConnection> | null = null;
let subscriberCount = 0;

export const signalrService = {
  connect: async (accessTokenFactory?: () => string | null) => {
    subscriberCount = Math.max(0, subscriberCount) + 1;
    // Halihazırda bağlıysa döndür
    if (connection && connection.state === signalR.HubConnectionState.Connected) {
      return connection;
    }
    // Başlatma sürüyorsa aynı promiseyi döndür (StrictMode kaynaklı çift mount'larda yarış durumunu engeller)
    if (startingPromise) {
      return startingPromise;
    }

    const apiBase = process.env.REACT_APP_API_URL || '';
    const defaultHub = apiBase
      ? apiBase.replace(/\/api\/?$/, '') + '/hubs/tagcolors'
      : '/hubs/tagcolors';
    const hubUrl = process.env.REACT_APP_SIGNALR_URL || defaultHub;
    // eslint-disable-next-line no-console
    console.log('SignalR hubUrl:', hubUrl);

    const conn = new signalR.HubConnectionBuilder()
      .withUrl(hubUrl, {
        accessTokenFactory: () => accessTokenFactory?.() || '',
        withCredentials: true,
        transport: signalR.HttpTransportType.WebSockets,
        skipNegotiation: true,
      })
      .withAutomaticReconnect({ nextRetryDelayInMilliseconds: () => 1000 })
      .configureLogging(signalR.LogLevel.Debug)
      .build();

    startingPromise = conn
      .start()
      .then(() => {
        connection = conn;
        startingPromise = null;
        return conn;
      })
      .catch(err => {
        startingPromise = null;
        // start başarısızsa sayacı geri al
        subscriberCount = Math.max(0, subscriberCount - 1);
        throw err;
      });

    return startingPromise;
  },
  on: (eventName: string, callback: (...args: any[]) => void) => {
    connection?.on(eventName, callback);
  },
  off: (eventName: string, callback: (...args: any[]) => void) => {
    connection?.off(eventName, callback);
  },
  disconnect: async () => {
    // Abonelik azalt; başka aboneler varsa bağlantıyı açık bırak
    subscriberCount = Math.max(0, subscriberCount - 1);
    if (subscriberCount > 0) return;

    // Eğer başlatma devam ediyorsa tamamlanmasını bekleyip sonra durdur
    if (startingPromise) {
      try {
        await startingPromise;
      } catch {
        // start başarısızsa durduracak bir şey yok
      }
    }
    if (connection) {
      try {
        await connection.stop();
      } finally {
        connection = null;
      }
    }
  },
};
